import {Component, inject} from '@angular/core';
import {RefModelSidebarService} from '@q9elements/ui-kit/refmodels';

@Component({
  selector: 'q9rme-root-details-tab',
  templateUrl: './root-details-tab.component.html',
  styleUrls: ['./root-details-tab.component.scss']
})
export class RootDetailsTabComponent {
  protected refModelSidebarService = inject(RefModelSidebarService);

  public get refModelNode() {
    return this.refModelSidebarService?.refModelNode();
  }
}
